import { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
import CollapseCard from "../components/admin/CollapseCard";
import Modal from "../components/admin/Modal";
import { useToast } from "../components/toast/ToastProvider";
import Main from "../components/admin/Main";
import {
  createDropdown,
  deleteDropdown,
  updateDropdown,
  fetchDropdownByCategoryWise,
} from "../service/DropdownService";
import DropdownForm from "../components/admin/DropdownForm";
import DropdownList from "../components/admin/DropdownList";
import { Col, Row } from "react-bootstrap";

const Dropdown = () => {
  const [dropdown, setDropdown] = useState([]);
  const [selectedDropdown, setSelectedDropdown] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [categoryOptions] = useState(["Location", "HealthCare Category", "Community Category"]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [deletingId, setDeletingId] = useState(null);

  const toast = useToast();

  const loadDataByCategory = async (category) => {
    try {
      setLoading(true);
      if (!category) {
        setDropdown([]);
        return;
      }

      const filtered = await fetchDropdownByCategoryWise(category);
      setDropdown(filtered);
    } catch (error) {
      toast("Error fetching dropdown data", "ERROR");
      setDropdown([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  }, []);

  const handleSave = async (formData) => {
    try {
      const postData = {
        category: formData.category || null,
        title: formData.title,
      };

      if (selectedDropdown) {
        await updateDropdown(selectedDropdown.id, postData);
        toast("Dropdown Updated", "SUCCESS");
      } else {
        await createDropdown(postData);
        toast("Dropdown Added", "SUCCESS");
      }

      setShowModal(false);
      setSelectedDropdown(null);
      setViewMode(false);

      if (selectedCategory) {
        await loadDataByCategory(selectedCategory);
      }
    } catch (error) {
      toast("Error saving Dropdown", "ERROR");
    }
  };

  const handleEdit = (item) => {
    setSelectedDropdown(item);
    setViewMode(false);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        setDeletingId(id);
        await deleteDropdown(id);
        toast("Dropdown Deleted", "SUCCESS");

        if (selectedCategory) {
          await loadDataByCategory(selectedCategory);
        }
      } catch (error) {
        toast("Error deleting Dropdown", "ERROR");
      } finally {
        setDeletingId(null);
      }
    } else {
      toast("Delete cancelled", "ERROR");
    }
  };

  const handleCategoryChange = async (e) => {
    const value = e.target.value;
    setSelectedCategory(value);
    await loadDataByCategory(value);
  };

  return (
    <Main>
      <PageContainer
        title="Dropdown"
        buttonText={loading ? "Loading..." : "ADD"}
        onButtonClick={() => {
          setSelectedDropdown(null);
          setViewMode(false);
          setShowModal(true);
        }}
        disableButton={!selectedCategory}
      >
        <CollapseCard title="Filter by Category">
          <Row>
            <Col md={6} className="mb-3">
              <select
                id="category-filter"
                className="form-select"
                value={selectedCategory}
                onChange={handleCategoryChange}
              >
                <option value="">Select category </option>
                {categoryOptions.map((cat, idx) => (
                  <option key={idx} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </Col>
          </Row>
        </CollapseCard>

        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedDropdown(null);
            setViewMode(false);
          }}
          headerText={selectedDropdown ? "Edit Dropdown" : "Add Dropdown"}
          centered
        >
          <DropdownForm
            initialData={selectedDropdown}
            readOnly={viewMode}
            onSave={handleSave}
            loading={loading}
            setLoading={setLoading}
          />
          {viewMode && (
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => {
                  setLoading(true);
                  setTimeout(() => {
                    setViewMode(false);
                    setLoading(false);
                  }, 2000)
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Loading...
                  </>
                ) : (
                  "Edit"
                )}
              </button>
            </div>
          )}
        </Modal>
        <CollapseCard title="Dropdown List">
          {!selectedCategory ? (
            <div className="text-center text-muted p-4">
              <h6>Please choose a category to view data.</h6>
            </div>
          ) : loading ? (
            <div className="text-center p-4">Loading...</div>
          ) : (
            <DropdownList
              dropdown={dropdown}
              onEdit={handleEdit}
              onDelete={handleDelete}
              deletingId={deletingId}
            />
          )}
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default Dropdown;
